import co2 from "./co2.js";
import hosting from "./hosting.js";
import averageIntensity from "./data/average-intensities.min.js";
import marginalIntensity from "./data/marginal-intensities-2021.min.js";
import electricityMaps from "./data/electricity-maps/index.js";

export { co2, hosting, averageIntensity, marginalIntensity, electricityMaps };
export default {
  co2,
  hosting,
  averageIntensity,
  marginalIntensity,
  electricityMaps,
};
